import { render, staticRenderFns } from "./SectionParkingV1.vue?vue&type=template&id=4873892c&"
import script from "./SectionParkingV1.vue?vue&type=script&lang=js&"
export * from "./SectionParkingV1.vue?vue&type=script&lang=js&"
import style0 from "./SectionParkingV1.vue?vue&type=style&index=0&id=4873892c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsCommonOrganismParkingAccess: require('/app/components/organisms/common/OrganismParkingAccess.vue').default})
